export const portfolioHashMap = {
  "everest_low-risk-volatility": "4676c2de-175b-41db-b483-b5ad693639a8",
  everest_defensive: "889f1ae5-0f57-42d9-8c10-95091c347f50",
  everest_balanced: "8088d7be-7bfd-491a-843a-45265610d985",
  everest_growth: "102a11f1-a045-4c33-aa0f-c8ba0d623f56",
  everest_fundamental: "c23827ab-1d16-461e-9e2f-573e77fd5a1c",

  titan_growth: "44840d75-6e8f-427d-a960-3f33a8e1fa24",
  "titan_low-risk-volatility": "71870b82-8bfd-4f3c-af27-d8b9f56b1bdf",
  titan_fundamental: "13a20efe-1083-4a62-9dde-725f4f4f5eec",

  atlas_growth: "f7b72dd8-6178-4c7f-8338-1252af29903c",
  "atlas_low-risk-volatility": "b6daaac0-308b-4349-9eba-f8445fd29b3c",
  atlas_fundamental: "c8da575c-df6a-466c-ab5c-73e8fab23cd2",

  // Auto portfolios - Everest
  "everest_low-risk-volatility_auto": "ef2b18b6-f8cc-4230-876c-f0ef99740e55",
  everest_defensive_auto: "15291d3a-3a8d-4aba-94d6-2b34004a0ae1",
  everest_balanced_auto: "5e09428e-6097-4959-95c5-a1e21964d5ca",
  everest_growth_auto: "1279b495-a796-430c-b261-292868f7c0fd",
  everest_fundamental_auto: "a5daf46c-f17e-4cc3-9554-cdbb7da3cd98",

  // Auto portfolios - Titan
  "titan_low-risk-volatility_auto": "feef5071-d0a4-424b-a36f-372d55e7c2b0",
  titan_growth_auto: "786622f3-9e39-47ee-af72-8f5ad7029c0b",
  titan_fundamental_auto: "ea1f87a8-5291-463e-9693-780a3bd0fd59",

  // Auto portfolios - Atlas
  "atlas_low-risk-volatility_auto": "a70293cb-ef0b-485e-b66b-83ceaecc9a95",
  atlas_growth_auto: "cf6d42f3-52c7-41c7-a93c-53c69701676c",
  atlas_fundamental_auto: "bdef48bc-ca53-4c6a-a3cc-c222ba564ddc",

  // Core portfolios (no auto versions) - matching backend API names
  core_growth: "210407e5-f56d-4dfd-afee-20c77a45e87f",
  "core_low-risk-volatility": "26df8f25-db88-44fb-8f8d-9798a9b03f00",
  core_balanced: "9aebf173-77a7-40a1-9646-f854d43c53ba",
};

export const reversePortfolioHashMap = Object.fromEntries(
  Object.entries(portfolioHashMap).map(([key, value]) => [value, key]),
);

// Helper function to get the base portfolio name without the _auto suffix
export const getBasePortfolioName = (portfolioName) => {
  return portfolioName?.replace("_auto", "");
};

// Map that normalizes portfolio IDs to their base portfolio names (without _auto)
export const normalizedReversePortfolioHashMap = Object.fromEntries(
  Object.entries(portfolioHashMap).map(([key, value]) => [
    value,
    key.replace("_auto", ""), // Remove _auto suffix for normalized mapping
  ]),
);

// Check if a portfolio ID belongs to an auto portfolio
export const isAutoPortfolio = (portfolioId) => {
  const portfolioName = reversePortfolioHashMap[portfolioId];
  return portfolioName?.includes("_auto");
};

// Get the auto version ID of a regular portfolio name if it exists
export const getAutoPortfolioId = (portfolioName) => {
  if (!portfolioName) return null;
  const autoName = `${portfolioName}_auto`;
  return portfolioHashMap[autoName];
};

// Get the regular version ID of an auto portfolio name if it exists
export const getRegularPortfolioId = (autoPortfolioName) => {
  if (!autoPortfolioName) return null;
  const regularName = autoPortfolioName.replace("_auto", "");
  return portfolioHashMap[regularName];
};
